import { render, staticRenderFns } from "./DetectionView.vue?vue&type=template&id=16d651fd&scoped=true"
import script from "./DetectionView.vue?vue&type=script&lang=js"
export * from "./DetectionView.vue?vue&type=script&lang=js"
import style0 from "./DetectionView.vue?vue&type=style&index=0&id=16d651fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d651fd",
  null
  
)

export default component.exports